module.exports = __webpack_public_path__ + "img/Unidad14-7.e9cfcb8a.png";